import { IconButton } from '@mui/material';
import { IconClose } from 'assets/icons';
import { useTranslation } from 'react-i18next';
import TooltipCC from '../TooltipCC';
import './index.css';

export default function TextareaAutosize({ fullWidth = false, clearInput, onClearInput, ...props }) {

    const { t } = useTranslation()

    return (
        <div className='textarea-container' style={{ position: 'relative', width: fullWidth ? '100%' : 320 }}>
            <textarea
                className={`textarea-auto-size ${props?.error ? 'cc-error' : ''}`}
                style={{ width: fullWidth ? '100%' : 320 }}
                {...props}
            />
            {props?.error && props?.helperText &&
                <p className='MuiFormHelperText-root Mui-error'>
                    {props.helperText}
                </p>
            }
            {
                false && <TooltipCC title={t('actions.clearInput')}>
                    <IconButton
                        onClick={onClearInput}
                        sx={{ 
                            position: 'absolute',
                            top: 6,
                            right: 12,
                            p: 0
                        }}
                    >
                        <IconClose />
                    </IconButton>
                </TooltipCC>
            }
        </div>
    );
}
